import React from 'react';
import RsltTechStepperContainer from '../../containers/rslttechmng/RsltTechStepperContainer';

const RsltTechViewPage = () => {
  return <RsltTechStepperContainer />
};

export default RsltTechViewPage;
